import { render, staticRenderFns } from "./TopBarHeadline.vue?vue&type=template&id=715af6c6&scoped=true&"
import script from "./TopBarHeadline.vue?vue&type=script&lang=js&"
export * from "./TopBarHeadline.vue?vue&type=script&lang=js&"
import style0 from "./TopBarHeadline.vue?vue&type=style&index=0&id=715af6c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715af6c6",
  null
  
)

export default component.exports